module.exports = __webpack_public_path__ + "img/primary_9x4.21047ea4.svg";